export class ChangeUseSkillURL {
   public static readonly type = '[WebViewerSettings] Change use skill url';

   constructor(public brickInstanceId: string, public useSkillURL: boolean) {}
}

export class ChangeTagDrivenURL {
   public static readonly type = '[WebViewerSettings] Change tag driven url';

   constructor(public brickInstanceId: string, public tagDrivenURL: string) {}
}
export class ChangeAllowAttributes {
   public static readonly type = '[WebViewerSettings] Change allow attributes';

   constructor(public brickInstanceId: string, public allowAttributes: string) {}
}
